import React from 'react';

const Category = React.lazy(() => import('./pages/settings/Category'));
const Dashboard = React.lazy(() => import('./pages/dashboard/Dashboard'));
const Task = React.lazy(() => import('./pages/task/Task'));
const TaskField = React.lazy(() => import('./pages/settings/TaskField'));
const User = React.lazy(() => import('./pages/settings/User'));
const Role = React.lazy(() => import('./pages/settings/Role'));
const Performance = React.lazy(() => import('./pages/settings/Performance'));
const PerformanceEvaluation = React.lazy(() => import('./pages/PerformanceEvaluation/PerformanceEvaluation'));
const AdminSetting = React.lazy(() => import('./pages/settings/AdminSetting'));
const CustomTask = React.lazy(() => import('./pages/settings/CustomTask'));
const ReviewField = React.lazy(() => import('./pages/settings/ReviewField'));

const routes = [
    {
        name: 'Dashboard',
        module: '',
        path: 'dashboard',
        component: Dashboard,
        icon: 'Dashboard',
        protected: true,
    },
    {
        name: 'Task',
        module: '',
        path: 'task-board',
        component: Task,
        icon: 'ListAlt',
        protected: true,
    },
    {
        name: 'Settings',
        module: '',
        icon: 'Settings',
        children: [
            { name: 'User', path: 'settings/user', component: User, icon: 'Person', protected: true },
            { name: 'Task Field', path: 'settings/task-field', component: TaskField, icon: 'Task', protected: true },
            { name: 'Category', path: 'settings/category', component: Category, icon: 'Category', protected: true },
            { name: 'Role', path: 'settings/role', component: Role, icon: 'SupervisorAccount', protected: true },
            { name: 'Performance', path: 'settings/performance', component: Performance, icon: 'BarChart', protected: true },
            { name: 'Admin Setting', path: 'settings/admin-setting', component: AdminSetting, icon: 'AdminPanelSettings', protected: true },
            { name: 'Custom Task', path: 'settings/custom-task', component: CustomTask, icon: 'Repeat', protected: true },
            { name: 'Review Field', path: 'settings/review-field', component: ReviewField, icon: 'CheckCircle', protected: true },
        ],
    },
    {
        name: 'Performance Evaluation',
        module: '',
        path: 'performance-evaluation',
        component: PerformanceEvaluation,
        icon: 'Assessment',
        protected: true,
    },
];

export default routes;
